import { aboutData } from '@/mocks/tanhua';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
              {aboutData.title}
            </h2>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutData.content}
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1 whitespace-nowrap">20000+</div>
                <div className="text-xs md:text-sm text-foreground-500">探花视频资源</div>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-accent-500 mb-1 whitespace-nowrap">50+</div>
                <div className="text-xs md:text-sm text-foreground-500">每日更新数量</div>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1 whitespace-nowrap">100万+</div>
                <div className="text-xs md:text-sm text-foreground-500">活跃爱好者</div>
              </div>
              <div className="text-center p-4">
                <div className="text-2xl md:text-3xl font-heading text-accent-500 mb-1 whitespace-nowrap">8+</div>
                <div className="text-xs md:text-sm text-foreground-500">主题分类</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}